/* tslint:disable */
/* eslint-disable */
/**
 * Protected Bricks API
 * API für die Verwaltung und Analyse von Klemmbaustein-Sets auf Design-Schutzrechte
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: support@protectedbricks.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Pageable } from './Pageable';
import {
    PageableFromJSON,
    PageableFromJSONTyped,
    PageableToJSON,
} from './Pageable';
import type { ProtectedBrickItem } from './ProtectedBrickItem';
import {
    ProtectedBrickItemFromJSON,
    ProtectedBrickItemFromJSONTyped,
    ProtectedBrickItemToJSON,
} from './ProtectedBrickItem';

/**
 * 
 * @export
 * @interface ProtectedBricksPageable
 */
export interface ProtectedBricksPageable {
    /**
     * Array of protected bricks
     * @type {Array<ProtectedBrickItem>}
     * @memberof ProtectedBricksPageable
     */
    items: Array<ProtectedBrickItem>;
    /**
     * 
     * @type {Pageable}
     * @memberof ProtectedBricksPageable
     */
    meta: Pageable;
}

/**
 * Check if a given object implements the ProtectedBricksPageable interface.
 */
export function instanceOfProtectedBricksPageable(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "items" in value;
    isInstance = isInstance && "meta" in value;

    return isInstance;
}

export function ProtectedBricksPageableFromJSON(json: any): ProtectedBricksPageable {
    return ProtectedBricksPageableFromJSONTyped(json, false);
}

export function ProtectedBricksPageableFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProtectedBricksPageable {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'items': ((json['items'] as Array<any>).map(ProtectedBrickItemFromJSON)),
        'meta': PageableFromJSON(json['meta']),
    };
}

export function ProtectedBricksPageableToJSON(value?: ProtectedBricksPageable | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'items': ((value.items as Array<any>).map(ProtectedBrickItemToJSON)),
        'meta': PageableToJSON(value.meta),
    };
}

